export enum FilterableAttributeValue {
  Required = 'required',
  Cyclical = 'cyclical'
}
